import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PaymentResultService } from '@components/checkout/services/payment-result.service';

export const clearPaymentResultGuard: CanActivateFn = () => {
    const paymentResultService = inject(PaymentResultService);
    paymentResultService.clear();
    return true;
};